import adminApiClient from '../../api/base/adminApiClient'

export interface ReviewKeyword {
  id: number
  name: string
  order: number
  created_at: string
  updated_at: string
}

export interface GetReviewKeywordsResponse {
  data: ReviewKeyword[]
  current_page: number
  last_page: number
  per_page: number
  total: number
}

export interface GetReviewKeywordsParams {
  page?: number
  per_page?: number
  search?: string
}

export interface CreateReviewKeywordRequest {
  name: string
  order?: number
}

export interface CreateReviewKeywordResponse {
  message: string
  data: ReviewKeyword
}

export interface UpdateReviewKeywordRequest {
  name: string
  order?: number
}

export interface UpdateReviewKeywordResponse {
  message: string
  data: ReviewKeyword
}

export interface DeleteReviewKeywordResponse {
  message: string
}

export interface ReviewKeywordSuggestion {
  id: number
  suggestion_text: string
  user: {
    id: number
    username: string
    nickname: string
  } | null
  created_at: string
  updated_at: string
}

export interface GetReviewKeywordSuggestionsResponse {
  data: ReviewKeywordSuggestion[]
  current_page: number
  last_page: number
  per_page: number
  total: number
}

export interface GetReviewKeywordSuggestionsParams {
  page?: number
  per_page?: number
  search?: string
}

export const adminReviewKeywordApi = {
  getReviewKeywords: async (
    params?: GetReviewKeywordsParams
  ): Promise<GetReviewKeywordsResponse> => {
    const response = await adminApiClient.get<GetReviewKeywordsResponse>(
      '/admin/review-keywords',
      {
        params,
      }
    )
    return response.data
  },

  createReviewKeyword: async (
    data: CreateReviewKeywordRequest
  ): Promise<CreateReviewKeywordResponse> => {
    const response = await adminApiClient.post<CreateReviewKeywordResponse>(
      '/admin/review-keywords',
      data
    )
    return response.data
  },

  updateReviewKeyword: async (
    id: number,
    data: UpdateReviewKeywordRequest
  ): Promise<UpdateReviewKeywordResponse> => {
    const response = await adminApiClient.put<UpdateReviewKeywordResponse>(
      `/admin/review-keywords/${id}`,
      data
    )
    return response.data
  },

  deleteReviewKeyword: async (
    id: number
  ): Promise<DeleteReviewKeywordResponse> => {
    const response = await adminApiClient.delete<DeleteReviewKeywordResponse>(
      `/admin/review-keywords/${id}`
    )
    return response.data
  },

  getReviewKeywordSuggestions: async (
    params?: GetReviewKeywordSuggestionsParams
  ): Promise<GetReviewKeywordSuggestionsResponse> => {
    const response = await adminApiClient.get<GetReviewKeywordSuggestionsResponse>(
      '/admin/review-keyword-suggestions',
      {
        params,
      }
    )
    return response.data
  },
}
